import {
    TagIcon,
    ShieldCheckIcon,
    PhoneIcon,
    CalendarDaysIcon,
} from "@heroicons/react/24/outline";

export default function BookingBenefits() {
    const benefits = [
        {
            icon: TagIcon,
            title: "Best Price Guarantee",
            description: "Get the lowest rates",
        },
        {
            icon: ShieldCheckIcon,
            title: "Secure Booking",
            description: "Your data is safe",
        },
        {
            icon: PhoneIcon,
            title: "24/7 Customer Support",
            description: "We're always here to help",
        },
        {
            icon: CalendarDaysIcon,
            title: "Free Cancellation",
            description: "Flexible plans when you need them",
        },
    ];

    return (
        <section
            className="
        w-full
        bg-[#F7F5EF]
        px-4
        py-6

        sm:px-6
        sm:py-8

        lg:px-8
        lg:py-12
    "
        >
            <div className="mx-auto w-full max-w-[1310px]">

                {/* =====================================================
            BENEFITS STRIP
        ===================================================== */}

                <div
                    className="
                grid
                grid-cols-1
                overflow-hidden

                rounded-xl
                border
                border-[#E5E0D5]

                sm:grid-cols-2
                sm:rounded-none
                sm:border-0

                lg:grid-cols-4
            "
                >

                    {benefits.map((benefit, index) => {
                        const Icon = benefit.icon;

                        return (
                            <div
                                key={benefit.title}
                                className={`
                            group
                            relative
                            flex
                            w-full
                            items-center
                            justify-start

                            gap-4

                            px-4
                            py-5

                            sm:px-5
                            sm:py-6

                            lg:justify-center
                            lg:px-7
                            lg:py-5

                            transition-all
                            duration-300

                            hover:bg-white/50

                            ${index !== benefits.length - 1
                                        ? `
                                        border-b
                                        border-[#E5E0D5]

                                        sm:border-b
                                    `
                                        : ""
                                    }

                            ${index === 1
                                        ? `
                                        sm:border-r
                                        sm:border-[#E5E0D5]

                                        lg:border-r
                                    `
                                        : ""
                                    }

                            ${index === 2
                                        ? `
                                        sm:border-r-0

                                        lg:border-r
                                        lg:border-[#E5E0D5]
                                    `
                                        : ""
                                    }

                            lg:border-b-0
                        `}
                            >

                                {/* =================================================
                            ICON
                        ================================================= */}

                                <div
                                    className="
                                relative
                                flex
                                h-[46px]
                                w-[46px]
                                shrink-0
                                items-center
                                justify-center
                                rounded-full

                                bg-[#EFE9DA]

                                transition-all
                                duration-300

                                group-hover:bg-[#E5D8B8]
                                group-hover:scale-105

                                sm:h-[50px]
                                sm:w-[50px]

                                lg:h-[52px]
                                lg:w-[52px]
                            "
                                >

                                    {/* Gold accent ring */}

                                    <div
                                        className="
                                    absolute
                                    inset-[4px]
                                    rounded-full
                                    border
                                    border-[#D5A33C]/30
                                "
                                    />

                                    <Icon
                                        className="
                                    h-[21px]
                                    w-[21px]
                                    text-[#0B5552]

                                    sm:h-[23px]
                                    sm:w-[23px]

                                    lg:h-[24px]
                                    lg:w-[24px]
                                "
                                        strokeWidth={1.6}
                                    />

                                </div>

                                {/* =================================================
                            CONTENT
                        ================================================= */}

                                <div className="min-w-0 flex-1">

                                    <h3
                                        className="
                                    mb-1

                                    text-[13px]
                                    font-semibold
                                    leading-tight
                                    text-[#0B5552]

                                    sm:text-[14px]
                                "
                                    >
                                        {benefit.title}
                                    </h3>

                                    <p
                                        className="
                                    max-w-full

                                    text-[11px]
                                    leading-[1.45]
                                    text-[#718080]

                                    sm:text-[12px]
                                    sm:leading-5
                                "
                                    >
                                        {benefit.description}
                                    </p>

                                </div>

                            </div>
                        );
                    })}

                </div>

            </div>
        </section>
    );
}